module.exports = __webpack_public_path__ + "static/media/ic_selectArrowDownWhite.ee535eb8.svg";